module.exports = __webpack_public_path__ + "img/order.39e054bb.svg";